import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import driversHeaders from "@/pages/Maintenance/Drivers/driversHeaders";

export default {
	state: {
		driversItem: null,
		driversId: null,
		driversFilters: null,
		driversList: null,
		driversLimit: null,
		driversOrder: null,
		driversSort: null,
		driversTotal: null,
		driversTotals: null,

		contract: [],
		filterContract: {},
		deleteDriversFilesList: [],
		deleteContractsList: [],

		driversLogs: [],
		driversLogsFilter: {},

	},
	mutations: {
		updateDriversList(state, { rows, limit, order, sort, total }) {
			state.driversList = rows;
			state.driversLimit = limit;
			state.driversOrder = order;
			state.driversSort = sort;
			state.driversTotal = total;
			state.driversTotals = { id: total };
		},
		updateDriversFilters(state, { filter }) {
			state.driversFilters = filter;
		},
		getDriverDeleteFiles({ commit }, { id, isDelete }) {
			commit('updateDriverDeleteFiles', { id, isDelete });
		},

		updateDriversFilter(state, payload) {
			state.contract = payload;
		},
		updateDriverDeleteFiles(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteDriversFilesList = [];
			} else {
				state.deleteDriversFilesList.push(id);
			}
		},
		updateContractDelete(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteContractsList = [];
			} else {
				state.deleteContractsList.push(id);
			}
		},
		updateSetContract(state, { row, filterContract }) {
			state.contract.push(row);
			state.filterContract = filterContract;
		},
		updateContractUpdate(state, { row, filterContract }) {
			const idx = state.contract.findIndex(item => item.id === row.id);
			if (idx !== -1) {
				state.contract.splice(idx, 1, row);
			}

			state.filterContract = filterContract;
		},
		updateDriversItem(state, { data, requestKey }) {
			state.driversItem = data;
			state.driversId = requestKey;
		},
		updateLogs(state, payload) {
			state.driversLogs = payload?.logs || [];
			state.driversLogsFilter = payload?.logsFilter || {};
		},
	},
	actions: {

		async getDrivers({ commit, dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/drivers/list', filters);

				if (data && !data.status) {
					commit('updateDriversList', data);
					commit('updateSettings', {
						settings: data.settings,
						key: requestKeys.TRUCKS,
						defaultHeader: driversHeaders
					});
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getDriversFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/drivers/filters', values);
				if (data) commit('updateDriversFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async getFilterLogs({ commit }, values) {
			try {
				const { data } = await httpClient.post('/drivers/filterLogs', values);
				if (data) commit('updateLogs', data);
			} catch (e) {
				console.error(e);
			}
		},

		async onDriversFilterLogs({ commit, state }, values) {
			values.driver_id = state.driversId;
			try {
				const { data } = await httpClient.post(`/drivers/filterLogs`, values);

				if (data && !data.status) {
					await commit("updateLogs", data);
				}
			} catch (error) {
				console.error(error);
			}
		},

		async onDriversSave({ dispatch }, { values, id }) {
			dispatch("actionPreloader", true);
			await dispatch('onContractDelete');
			const url = id ? `/drivers/update/${ id }` : '/drivers/new';
			try {
				const { data } = await httpClient.post(url, values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onDriversRemoveItem({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`/drivers/${ id }`);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "The removal was successful" });
				} else {
					dispatch('setAlert', { type: "error", message: "Deletion error" });
				}

				return data;
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onContractShow({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/drivers/showContract/${ id }`);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onContractUpdate({ commit }, values) {
			const { id, ...obj } = values;
			try {
				const { data } = await httpClient.post(`/drivers/updateContract/${ id }`, obj);
				if (data && data.row) {
					commit('updateContractUpdate', data);
					return null;
				}
				return data?.error?.contract;

			} catch (e) {
				console.error(e);
			}
		},

		async onSetContract({ commit }, values) {
			const { id, ...obj } = values;
			try {
				const { data } = await httpClient.post(`/drivers/setContract/${ id }`, obj);
				if (data && data.row) {
					commit('updateSetContract', data);
					return null;
				}
				console.error('Something wrong');
				return data?.error?.contract;

			} catch (e) {
				console.error(e);
			}
		},

		async onDriversFilter({ commit }, { id, filters }) {
			try {
				const { data } = await httpClient.post(`/drivers/contract/${ id }`, filters);

				if (data && !data.status) {
					commit("updateDriversFilter", data.contract);
				}
			} catch (error) {
				console.error(error);
			}
		},

		async getDriversItem({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			const requestKey = id ?? "new";
			try {
				const { data } = await httpClient.get(`/drivers/${ requestKey }`);

				if (data && !data.status) {
					commit("updateDriversItem", { data, requestKey });
					commit("updateDriversFilter", data.contract);
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async getCustomerInfoForDriver({ dispatch }, value) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/customers/${ value }`);
				if (data && !data.status) {
					return data;
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		onClearDriversList({ commit }) {
			commit('updateCustomersList', null);
		},

		async onDriverDeleteFiles({ state }) {
			if (state.deleteDriversFilesList.length) await httpClient.post(`/drivers/destroyFiles`, { ids: state.deleteDriversFilesList });
		},

		async onContractDelete({ state }) {
			if (state.deleteContractsList.length) await httpClient.post(`/drivers/destroyContract`, { ids: state.deleteContractsList });
		},

		getContractDelete({ commit }, { id, isDelete }) {
			commit('updateContractDelete', { id, isDelete });
		},

		getDriverDeleteFiles({ commit }, { id, isDelete }) {
			commit('updateDriverDeleteFiles', { id, isDelete });
		},

	},
	getters: {
		driversItem: (s) => s.driversItem,
		driversList: (s) => s.driversList,
		driversFilters: (s) => s.driversFilters,
		driversTotals: (s) => s.driversTotals,
		driversLimit: (s) => s.driversLimit,
		driversOrder: (s) => s.driversOrder,
		driversSort: (s) => s.driversSort,
		driversTotal: (s) => s.driversTotal,
		filterContract: s => s.filterContract,
		contract: s => s.contract,
		driversLogs: s => s.driversLogs,
		driversLogsFilter: s => s.driversLogsFilter,
	}
};
